import { stripLocaleFromPath } from '@/lib/locales'

export const GTM_ID = 'GTM-WLZGF43D'

const RESERVED_ROOTS = new Set([
  'specialists',
  'blog',
  'wiki',
  'promotions',
  'contacts',
  'services',
  'search',
  'reviews',
  'cookie-policy',
  'patient-and-family-bill-of-rights-and-responsibilities',
  'patient-rights-and-responsibilities',
  'ar',
])

/**
 * Базовый dataLayer из CMS / маршрута.
 * pageType: home | direction | service | specialist | article | contacts
 */
export function buildGtmDataLayer(pageProps = {}, asPath = '/') {
  const path = stripLocaleFromPath(asPath)
  const segments = path.split('/').filter(Boolean)

  let pageType = pageProps.pageType || null
  let directionSlug = null
  let serviceSlug = null

  if (!pageType) {
    if (path === '/') {
      pageType = 'home'
    } else if (segments[0] === 'contacts') {
      pageType = 'contacts'
    } else if (segments[0] === 'specialists' && segments[1]) {
      pageType = 'specialist'
    } else if ((segments[0] === 'blog' || segments[0] === 'wiki') && segments[1]) {
      pageType = 'article'
    } else if (pageProps.type === 'direction' || pageProps.type === 'subdirection') {
      pageType = 'direction'
    } else if (
      pageProps.direction ||
      (segments.length >= 2 && !RESERVED_ROOTS.has(segments[0]))
    ) {
      pageType = 'service'
    }
  }

  if (pageType === 'direction') {
    directionSlug =
      pageProps.data?.slug ||
      pageProps.data?.current_direction?.slug ||
      segments[0] ||
      null
  }

  if (pageType === 'service') {
    directionSlug = pageProps.direction?.slug || segments[0] || null
    serviceSlug = pageProps.slug || segments[1] || null
  }

  return {
    pageType,
    directionSlug,
    serviceSlug,
  }
}

export function getGtmSnippet(gtmId = GTM_ID) {
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `
}

export function getDataLayerSnippet(data) {
  const payload = {
    pageType: data?.pageType ?? null,
    directionSlug: data?.directionSlug ?? null,
    serviceSlug: data?.serviceSlug ?? null,
  }

  return `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(${JSON.stringify(payload)});
  `
}

export function pushGtmDataLayer(data, { event } = {}) {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  const payload = {
    pageType: data?.pageType ?? null,
    directionSlug: data?.directionSlug ?? null,
    serviceSlug: data?.serviceSlug ?? null,
  }

  if (event) {
    payload.event = event
  }

  window.dataLayer.push(payload)
}
